const LoadingCircle = () => {
  return <span className="loading loading-spinner loading-xs"></span>;
};
export const LOADING_CIRCLE = <LoadingCircle />;
